// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-select[data-v-82fa7a0e] {\n  width: 360px;\n}\n.el-select.gorup-select-item[data-v-82fa7a0e] {\n  width: 100%;\n}", ""]);
// Exports
module.exports = exports;
